import { AnalyticsMetaKeys as key } from '../../../../../../services/analytics/formatters/meta-keys'
import { Num } from '../../../../../../utils/common'
import { DOMEvents } from '../../../../../../utils/dom'
import { AnalyticsEvent } from '../../../../event'
import { AttributeFormatter } from '../../formatters/attribute'
import { PageEvents } from '../../page-events'

export interface IPerformance {
    domComplete: any
}

export interface IWindow extends Window {
    performance: any
}

declare let window: IWindow

const mParticleEvents: any = new PageEvents()

/**
 * TODO Clean up FEM from any PageData event code
 */
export class PageData extends AnalyticsEvent {

    public attributeFormatter = new AttributeFormatter()

    public static commonAttrs() {
        return [
            key.DOMAIN,
            key.TITLE,
            key.TYPE,
            key.GLOBAL_ID,
            key.CANONICAL_PATH,
            key.CATEGORY,
            key.ARTICLE_ID,
            key.ORIGINAL_ID,
            key.VERSION,
            key.ALL_SUB_SEC,
            key.SUB_SEC,
            key.SUB_SEC_2,
            key.SUB_SEC_3,
            key.MAIN_CATEGORY,
            key.DISTRIBUTOR,
            key.KLNGO_ENTITY,
            key.KLNGO_CATEGORY,
            key.NLP_ENTITY,
            key.NLP_TOPIC,
            key.DIVISION,
            key.BRAND,
            key.WRITERS,
            key.BYLINE,
            key.WIRE_AUTHORS,
            key.IS_WIRE,
            key.PAYWALL,
            key.METERED_CONTENT_TYPE,
            key.META_TAG,
            key.PAGE_RES_TIME,
            key.PUB_DATE,
            key.PUB_TIME,
            key.WRD_CNT,
            key.SLUG,
            key.DEBUG,
            key.CUR_PAGE,
            key.IS_ORIGINAL,
            key.VENDOR,
            key.USER_LOGGEDIN
        ]
    }

    /**
     * Handle a story page load event
     */
    public handle() {

        /**
         * @var attrs will be different for each
         * events
         *
         * there are events which has will have attributes
         * both from dom element and page meta properties
         */

        const attrs = PageData.commonAttrs()

        const data = this.attributeFormatter.format(attrs, this.metaProperties || {})

        window.addEventListener(DOMEvents.load, () => {
            const perfEntries = window.performance.getEntriesByType('navigation')[0]
            data[key.PAGE_RES_TIME] = String((perfEntries.domComplete / Num.secToMs).toFixed(Num.decPrecision))
            mParticleEvents.logEvent(
                PageEvents.mpEventName.PageData,
                PageEvents.mpEventType.Navigation,
                data,
                {'Google.NonInteraction': true}
            )
        })
    }
}
